import environment from "src/utils/environment";
import debug from "src/modules/debug-logger";
import { getEnvironmentVariable } from "src/utils/environment";

const createBonjour = window.require("bonjour");
const os = window.require("os");
const { isBrowser } = environment;

export default class DeviceDiscovery {
  constructor({ xmppLogin, name, code }) {
    if (!isBrowser) {
      this.xmppLogin = xmppLogin;
      this.code = code;
      this.name = name;
      this.type = getEnvironmentVariable("BONJOUR_SUFFIX");
      this.host = this.type + "-" + os.hostname();
      this.protocol = "tcp";
      this.platformType = "9";
      this.port = 4321;

      this.stopBroadcastingPromise = null;
      this.bonjour = createBonjour();
    }
  }

  async startBroadcasting({ familyname }) {
    if (isBrowser) return;
    if (this.stopBroadcastingPromise) await this.stopBroadcastingPromise;
    if (this.deviceService && this.deviceService.published) return;

    const options = {
      name: this.xmppLogin,
      host: this.host,
      port: this.port,
      type: this.type,
      protocol: this.protocol,
      txt: {
        id: this.xmppLogin,
        name: this.name,
        code: this.code
      }
    };
    if (familyname) options.txt.familyname = familyname;

    debug.deviceDiscovery("Starting to broadcast.", options);

    this.deviceService = this.bonjour.publish(options);
    this.deviceService.on("error", (err) => debug.deviceDiscovery(err));
  }
  updateTxt = async (update) => {
    if (isBrowser) return;
    if (this.deviceService) {
      await this.stopBroadcasting();
    }
    this.startBroadcasting(update);
  };
  async stopBroadcasting() {
    if (isBrowser) return;
    try {
      this.stopBroadcastingPromise = new Promise((resolve) => {
        this.deviceService ? this.deviceService.stop(resolve) : resolve();
      });
      await this.stopBroadcastingPromise;
    } catch (error) {
      debug.deviceDiscovery(error);
    } finally {
      this.stopBroadcastingPromise = null;
      this.deviceService = null;
    }
  }

  async startBrowsing() {
    if (isBrowser) {
      return {
        on(type) {
          return undefined;
        }
      };
    }
    if (this.stopBroadcastingPromise) {
      await this.stopBroadcastingPromise;
    }
    if (this.deviceBrowser) {
      this.deviceBrowser.start();
      return this.deviceBrowser;
    }
    this.deviceBrowser = this.bonjour.find(
      {
        type: this.type,
        protocol: this.protocol
      },
      (service) => debug.deviceDiscovery("bonjour.onFind() fired", service)
    );

    this.deviceBrowser.on("error", (err) => debug.deviceDiscovery(err));
    return this.deviceBrowser;
  }

  stopBrowsing() {
    if (isBrowser) return;
    if (this.deviceBrowser) {
      this.deviceBrowser.stop();
    }
  }

  async destroy() {
    if (isBrowser) return;
    await this.stopBroadcasting();
    this.bonjour.destroy();
  }
}
